import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faNetworkWired, 
  faWifi, 
  faServer, 
  faDesktop,
  faLaptop,
  faPhoneAlt
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const IukPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faNetworkWired} />
            </div>
            <h1>Informations- und Kommunikationstechnik</h1>
            <p>
              Moderne IuK-Lösungen für vernetzte und zukunftssichere Gebäude
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Fachplanung für Informations- und Kommunikationstechnik</h2>
            <p>
              Im Bereich der Informations- und Kommunikationstechnik (IuK) bietet das Ingenieurbüro Neubaur 
              umfassende Planungsleistungen für moderne, leistungsfähige und zukunftssichere Netzwerk- und 
              Kommunikationsinfrastrukturen in Gebäuden aller Art.
            </p>
            <p>
              Wir planen maßgeschneiderte IuK-Lösungen, die den steigenden Anforderungen an Datenübertragung, 
              Kommunikation und Vernetzung gerecht werden und gleichzeitig flexibel für zukünftige Entwicklungen sind.
            </p>
          </section>

          {/* Features Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich IuK</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faNetworkWired} />
                </div>
                <h3 className="service-feature-title">Strukturierte Verkabelung</h3>
                <p className="service-feature-text">
                  Planung von zukunftssicheren Netzwerkinfrastrukturen mit strukturierter Verkabelung nach aktuellen Standards.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faWifi} />
                </div>
                <h3 className="service-feature-title">WLAN-Systeme</h3>
                <p className="service-feature-text">
                  Konzeption und Planung von flächendeckenden WLAN-Lösungen für optimale drahtlose Konnektivität.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faServer} />
                </div>
                <h3 className="service-feature-title">Serverräume und Rechenzentren</h3>
                <p className="service-feature-text">
                  Planung von Serverräumen und kleinen Rechenzentren mit entsprechender Infrastruktur.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faPhoneAlt} />
                </div>
                <h3 className="service-feature-title">Telefonanlagen</h3>
                <p className="service-feature-text">
                  Planung moderner IP-basierter Telefonanlagen und Kommunikationssysteme.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faDesktop} />
                </div>
                <h3 className="service-feature-title">Medientechnik</h3>
                <p className="service-feature-text">
                  Planung von Medientechnik für Konferenzräume, Schulungsräume und Präsentationsflächen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faLaptop} />
                </div>
                <h3 className="service-feature-title">Digitale Lernumgebungen</h3>
                <p className="service-feature-text">
                  Konzeption und Planung von digitalen Lernumgebungen für Schulen und Bildungseinrichtungen.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Planungsprozess</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Bedarfsanalyse</h3>
                  <p className="process-text">
                    Wir ermitteln Ihre spezifischen Anforderungen an die IuK-Infrastruktur und analysieren bestehende Systeme.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Konzeptentwicklung</h3>
                  <p className="process-text">
                    Basierend auf der Analyse entwickeln wir ein maßgeschneidertes IuK-Konzept für Ihr Projekt.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Detailplanung</h3>
                  <p className="process-text">
                    Wir erstellen detaillierte technische Planungen für alle IuK-Komponenten und -Systeme.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Ausschreibung und Vergabe</h3>
                  <p className="process-text">
                    Wir unterstützen bei der Ausschreibung und Vergabe der Leistungen an qualifizierte Unternehmen.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Bauüberwachung</h3>
                  <p className="process-text">
                    Während der Installationsphase überwachen wir die fachgerechte Umsetzung der IuK-Systeme.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">6</div>
                <div className="process-content">
                  <h3 className="process-title">Abnahme und Dokumentation</h3>
                  <p className="process-text">
                    Wir begleiten die Abnahme der Systeme und erstellen die erforderliche technische Dokumentation.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Zukunftssichere IuK-Infrastruktur für Ihr Projekt</h2>
            <p className="service-cta-text">
              Nutzen Sie unsere Expertise im Bereich Informations- und Kommunikationstechnik für Ihr nächstes Projekt. 
              Wir beraten Sie gerne zu modernen und zukunftssicheren IuK-Lösungen.
            </p>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default IukPage;
